import { client } from "../client/client";

export const getLoanProducts = async (
  page,
  limit,
  loanType,
  repaymentType,
  repaymentFrequency,
  query
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (loanType != null) params.append("loanType", loanType);
    if (repaymentType != null) params.append("repaymentType", repaymentType);
    if (repaymentFrequency != null)
      params.append("repaymentFrequency", repaymentFrequency);
    if (query != null) params.append("name", query);
    const response = await client.get(`/product?${params.toString()}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addLoanProduct = async (
  name,
  description,
  defaultInterestRate,
  minLoanPeriod,
  maxLoanPeriod,
  maxLoanAmount,
  minLoanAmount,
  repaymentType,
  repaymentFrequency,
  gracePeriod,
  userId,
  processingFee,
  insuranceFee,
  penaltyFee,
  documentsRequired,
  loanTermsAndConditions,
  otherCharges,
  loanType,
  processingFeeType
) => {
  try {
    const response = await client.post("/product", {
      name,
      description,
      defaultInterestRate,
      maxLoanPeriod,
      minLoanPeriod,
      maxLoanAmount,
      minLoanAmount,
      repaymentType,
      repaymentFrequency,
      gracePeriod,
      user_id: userId,
      processingFee,
      insuranceFee,
      penaltyFee,
      documentsRequired,
      loanTermsAndConditions,
      otherCharges,
      loanType,
      processingFeeType
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editLoanProduct = async (
  id,
  name,
  description,
  defaultInterestRate,
  minLoanPeriod,
  maxLoanPeriod,
  maxLoanAmount,
  minLoanAmount,
  repaymentType,
  repaymentFrequency,
  gracePeriod,
  userId,
  processingFee,
  insuranceFee,
  penaltyFee,
  documentsRequired,
  loanTermsAndConditions,
  otherCharges,
  loanType
) => {
  try {
    // Construct raw payload
    const payload = {
      name,
      description,
      defaultInterestRate,
      maxLoanPeriod,
      minLoanPeriod,
      maxLoanAmount,
      minLoanAmount,
      repaymentType,
      repaymentFrequency,
      gracePeriod,
      user_id: userId,
      processingFee,
      insuranceFee,
      penaltyFee,
      documentsRequired,
      loanTermsAndConditions,
      otherCharges,
      loanType,
    };

    // Remove null, undefined, and empty string values
    const cleanedPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) =>
          value !== null &&
          value !== undefined &&
          !(typeof value === "string" && value.trim() === "")
      )
    );

    const response = await client.patch(`/product/${id}`, cleanedPayload);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanProductById = async (productId) => {
  try {
    const response = await client.get(`/product/${productId}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getProductStatistics = async () => {
  try {
    const response = await client.get(`/product/stats`);
    return response.data.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
